/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-01-07 11:21:56
 * @LastEditors: K
 * @LastEditTime: 2022-08-16 16:53:27
 */
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'
import { api, sendAsync } from '../../app/applicationSlice'
import { RootState, RootThunk, RootThunkApi } from '../../app/store'
import { LoadingState } from '../../models/common'
import { fromJson, serviceDelay } from '../../models/serviceDelay'
import * as service from '../../services/serviceDelay'
interface servicedelay {
  creatingState: LoadingState
  states: []

}

const initialState: servicedelay = {
  creatingState: LoadingState.Idle,
  states: [],

}

const serviceDelaySlice = createSlice({
  name: 'serviceDelaySlice',
  initialState,
  reducers: {
    setCreatingState: (state, action: PayloadAction<LoadingState>) => {
      state.creatingState = action.payload
    },

    setState: (state, action) => {
      state.states = action.payload
    },

  },
})

export const { setCreatingState, setState } = serviceDelaySlice.actions

export const getDelayState = createAsyncThunk<
  void,
  service.ServiceDelayParams,
  RootThunkApi
>('Delay/getDelayStatus', async (body, api) => {
  return sendAsync(service.getDelay(body), api)
})
// 订单管理-新增订单-是否显示开始结束时间
export const getTimeShow = createAsyncThunk<
  void,
  service.getTimeShowFnParams,
  RootThunkApi
>('Delay/getTimeShow', async (body, api) => {
  return sendAsync(service.getTimeShowFn(body), api)
})


export const getTenantServerEndTimeFn = createAsyncThunk<
  void,
  service.GetTenantServerEndTimeParams,
  RootThunkApi
>('Delay/getTenantServerEndTime', async (params, api) => {
  return sendAsync(service.getTenantServerEndTime(params), api)
})

export const getPlatformIdList = createAsyncThunk<
  void,
  {
    current: number
    size: number
  },
  RootThunkApi
>('Delay/getPlatformIdList', async (body, api) => {
  return sendAsync(service.PlatformIdList(body), api)
})

export default serviceDelaySlice.reducer
